import { Routes } from '@angular/router';
import { ForgerockComponent } from './forge-rock.component';

export const forgeRockRoutes: Routes = [
  { path: '', component: ForgerockComponent },
  { path: '**', redirectTo: '' }
];
